import colors from 'vuetify/lib/util/colors'

export default {
    light: {
        primary: '#103D34',
        secondary: '#757575',
        accent: "#29abe2",
        bg_main: "#eee",

        // Tables
        title_table: '#CF202F',
        bg_table_th: '#CF202F',
        txt_table_th: '#fff',

        // NavBar
        bg_navbar: '#103D34',

        // main colors
        main_color: '#103D34',
        main_color_complementario: '#61726C',
        main_color_action: '#CF202F',

        //##### DASHBOARD TOP CARDS #####
        bg_home_card_1: '#f6931c',
        bg_home_card_1_avatar: '#f5881f',
        bg_home_card_1_title: '#f5a448',
        
        bg_home_card_2: '#28a9e2',
        bg_home_card_2_avatar: '#239cd3',
        bg_home_card_2_title: '#50b7e4',
        
        bg_home_card_3: '#f0605f',
        bg_home_card_3_avatar: '#f34d4f',
        bg_home_card_3_title: '#ef7b7c',
        
        bg_home_card_4: '#8dc73f',
        bg_home_card_4_avatar: '#72bc41',
        bg_home_card_4_title: '#a1cf62',

        //STATUS TEXT
        status_active: '#000000', // #f15a25
        status_process: '#f1c232', // #239cd3 anterior
        status_canceled: colors.pink.darken1,
        status_finished:  '#72bc41',

        //btn_download_invoice: colors.orange.lighten2,

        error: colors.red.lighten1,
        warning: colors.orange.lighten1,
    },

    icons:{
        //APP BAR
        logo_app_bar: 'img/logo_torreon.png',
        bg_login_theme: 'img/fondo_transparent.png',
        icon_portfolio: 'img/carrito.png',

        icon_test: '@/assets/icons/agricultura.svg',

        //###### DASHBOARD CARDS ICONS #####
        icon_home_card_1: 'img/pendiente_c.png',
        icon_home_card_2: 'img/proceso_c.png',
        icon_home_card_3: 'img/cancelado_c.png',
        icon_home_card_4: 'img/completado_c.png',

        // MAIN DRAWER NAVIGATION
        icon_new_process: 'img/nuevo_a.png',
        icon_new_process_selected: 'img/nuevo_b.png',
        icon_all: 'img/todo_a.png',
        icon_all_selected: 'img/todo_b.png',
        icon_pending: 'img/pendiente_a.png',
        icon_pending_selected: 'img/pendiente_b.png',
        icon_in_process: 'img/proceso_a.png',
        icon_in_process_selected: 'img/proceso_b.png',
        icon_canceled: 'img/cancelado_a.png',
        icon_canceled_selected: 'img/cancelado_b.png',
        icon_finished: 'img/completado_a.png',
        icon_fiished_selected: 'img/completado_b.png',
        icon_orders: 'img/ordenes_a.png',
        icon_orders_selected: 'img/ordenes_b.png',

        //PROCEDURES LIST
        icon_continue: 'img/continuar.png',
        icon_show_progress: 'img/progreso.png'
    }

}